import script from "./TransactionsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionsTable.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionsTable.vue?vue&type=style&index=0&id=7b203f80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b203f80"]])

export default __exports__